export default __webpack_public_path__ + "static/media/python.b7dca743.svg";